import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

export enum UrlPathTypes {
    AboutPage = "ABOUT_PAGE",
    AntiSlaveryStatementPage = "ANTI_SLAVERY_STATEMENT_PAGE",
    AuthorProfilePage = "AUTHOR_PROFILE_PAGE",
    BankDetailsPage = "BANK_DETAILS_PAGE",
    BlogIndex = "BLOG_INDEX",
    BlogIndexPage = "BLOG_INDEX_PAGE",
    BlogTopicPage = "BLOG_TOPIC_PAGE",
    BranchesPage = "BRANCHES_PAGE",
    BrowseCarsIndexPage = "BROWSE_CARS_INDEX_PAGE",
    BrowseVansIndexPage = "BROWSE_VANS_INDEX_PAGE",
    CareersSiteBranchesPage = "CAREERS_SITE_BRANCHES_PAGE",
    CareersSiteHomepage = "CAREERS_SITE_HOMEPAGE",
    CookiePolicyPage = "COOKIE_POLICY_PAGE",
    CustomerCarePage = "CUSTOMER_CARE_PAGE",
    CustomerReviewsPage = "CUSTOMER_REVIEWS_PAGE",
    DataSubjectAccessRequestPage = "DATA_SUBJECT_ACCESS_REQUEST_PAGE",
    ExtrasPage = "EXTRAS_PAGE",
    FaqPage = "FAQ_PAGE",
    FinanceIndexPage = "FINANCE_INDEX_PAGE",
    GenderPayGapReportPage = "GENDER_PAY_GAP_REPORT_PAGE",
    HomeDeliveryPage = "HOME_DELIVERY_PAGE",
    Homepage = "HOMEPAGE",
    MotorpointPlcSite = "MOTORPOINT_PLC_SITE",
    MotorpointPlcSiteTaxStrategyPage = "MOTORPOINT_PLC_SITE_TAX_STRATEGY_PAGE",
    MyMotorpointPage = "MY_MOTORPOINT_PAGE",
    MyMotorpointSectionPage = "MY_MOTORPOINT_SECTION_PAGE",
    NewsPage = "NEWS_PAGE",
    PressReleaseIndexPage = "PRESS_RELEASE_INDEX_PAGE",
    PrivacyPolicyPage = "PRIVACY_POLICY_PAGE",
    QualityStandardPage = "QUALITY_STANDARD_PAGE",
    ReserveAndCollectPage = "RESERVE_AND_COLLECT_PAGE",
    SameDayDriveawayPage = "SAME_DAY_DRIVEAWAY_PAGE",
    SponsorshipsPage = "SPONSORSHIPS_PAGE",
    TermsAndConditionsPage = "TERMS_AND_CONDITIONS_PAGE",
    UsedCarsIndexPage = "USED_CARS_PAGE",
    UsedCarsPage = "USED_CARS_MAKE_PAGE",
    UsedVansIndexPage = "USED_VANS_PAGE",
    UsedVansPage = "USED_VANS_PAGE",
    ValueMyCarPage = "VALUE_MY_CAR_PAGE",
    ShortlistPage = "SHORTLIST_PAGE",
    VehicleSearchResults = "VEHICLE_SEARCH_RESULTS",
    WhyChooseMotorpointPage = "WHY_CHOOSE_MOTORPOINT_PAGE",
    MyMotorpointLoginPage = "MY_MOTORPOINT_LOGIN_PAGE",
    BestIndexPage = "BEST_INDEX_PAGE",
    NewsIndexPage = "NEWS_INDEX_PAGE",
    GuidesIndexPage = "GUIDES_INDEX_PAGE",
    ComparisonIndexPage = "COMPARISON_INDEX_PAGE",
    BestArticlePage = "BEST_ARTICLE_PAGE",
    NewsArticlePage = "NEWS_ARTICLE_PAGE",
    GuidesArticlePage = "GUIDES_ARTICLE_PAGE",
    ComparisonArticlePage = "COMPARISON_ARTICLE_PAGE",
    EventsIndexPage = "EVENTS_INDEX_PAGE",
    EventsArticlePage = "EVENTS_ARTICLE_PAGE",
    MyMotorpointMyActivityPage = "MY_MOTORPOINT_MY_ACTIVITY_PAGE",
    SavedSearches = "SAVED_SEARCHES",
    SavedSearchesPage = "SAVED_SEARCHES_PAGE",
    ReviewsIndexPage = "REVIEWS_INDEX_PAGE",
    ReviewsByMakeIndexPage = "REVIEWS_BY_MAKE_INDEX_PAGE",
    ReviewsByMakePage = "REVIEWS_BY_MAKE_PAGE",
}

export type TypeWithSlug =
    | ContentTypeCodenames.ArticlePage
    | ContentTypeCodenames.AuthorProfile
    | ContentTypeCodenames.Topic
    | ContentTypeCodenames.PRArticlePage
    | ContentTypeCodenames.PressReleaseTopic
    | UrlPathTypes.BlogTopicPage
    | UrlPathTypes.VehicleSearchResults
    | UrlPathTypes.BestArticlePage
    | UrlPathTypes.NewsArticlePage
    | UrlPathTypes.GuidesArticlePage
    | UrlPathTypes.ComparisonArticlePage
    | UrlPathTypes.EventsArticlePage
    | UrlPathTypes.AuthorProfilePage
    | UrlPathTypes.ReviewsByMakeIndexPage
    | UrlPathTypes.ReviewsByMakePage;

export type TypeWithoutSlug =
    | ContentTypeCodenames.ReviewListingPage
    | ContentTypeCodenames.GuidesArticleListingPage
    | ContentTypeCodenames.ComparisonArticleListingPage
    | ContentTypeCodenames.NewsArticleListingPage
    | ContentTypeCodenames.BestArticleListingPage
    | ContentTypeCodenames.ArticleListingPage
    | ContentTypeCodenames.PRArticleListingPage
    | ContentTypeCodenames.EventsArticleListingPage
    | UrlPathTypes.AboutPage
    | UrlPathTypes.AntiSlaveryStatementPage
    | UrlPathTypes.BankDetailsPage
    | UrlPathTypes.BlogIndexPage
    | UrlPathTypes.NewsIndexPage
    | UrlPathTypes.BestIndexPage
    | UrlPathTypes.GuidesIndexPage
    | UrlPathTypes.ComparisonIndexPage
    | UrlPathTypes.PressReleaseIndexPage
    | UrlPathTypes.BranchesPage
    | UrlPathTypes.BrowseCarsIndexPage
    | UrlPathTypes.BrowseVansIndexPage
    | UrlPathTypes.CareersSiteBranchesPage
    | UrlPathTypes.CareersSiteHomepage
    | UrlPathTypes.CookiePolicyPage
    | UrlPathTypes.CustomerCarePage
    | UrlPathTypes.CustomerReviewsPage
    | UrlPathTypes.DataSubjectAccessRequestPage
    | UrlPathTypes.ExtrasPage
    | UrlPathTypes.FaqPage
    | UrlPathTypes.FinanceIndexPage
    | UrlPathTypes.GenderPayGapReportPage
    | UrlPathTypes.HomeDeliveryPage
    | UrlPathTypes.Homepage
    | UrlPathTypes.MotorpointPlcSite
    | UrlPathTypes.MotorpointPlcSiteTaxStrategyPage
    | UrlPathTypes.MyMotorpointPage
    | UrlPathTypes.MyMotorpointSectionPage
    | UrlPathTypes.MyMotorpointMyActivityPage
    | UrlPathTypes.NewsPage
    | UrlPathTypes.PrivacyPolicyPage
    | UrlPathTypes.QualityStandardPage
    | UrlPathTypes.ReserveAndCollectPage
    | UrlPathTypes.SameDayDriveawayPage
    | UrlPathTypes.SponsorshipsPage
    | UrlPathTypes.TermsAndConditionsPage
    | UrlPathTypes.UsedCarsIndexPage
    | UrlPathTypes.UsedCarsPage
    | UrlPathTypes.UsedVansIndexPage
    | UrlPathTypes.UsedVansPage
    | UrlPathTypes.ValueMyCarPage
    | UrlPathTypes.WhyChooseMotorpointPage
    | UrlPathTypes.ShortlistPage
    | UrlPathTypes.MyMotorpointLoginPage
    | UrlPathTypes.SavedSearches
    | UrlPathTypes.SavedSearchesPage
    | UrlPathTypes.EventsIndexPage
    | UrlPathTypes.ReviewsIndexPage;

export type AllPathTypes = TypeWithSlug | TypeWithoutSlug;

export type GetPathByTypeArgs =
    | { slug: string; type: TypeWithSlug; page?: string }
    | { type: TypeWithoutSlug; page?: string };

const getPathByType = (data: GetPathByTypeArgs): string => {
    switch (data.type) {
        case ContentTypeCodenames.ReviewListingPage:
            return "/car-reviews";
        case UrlPathTypes.ReviewsIndexPage:
            return `/car-reviews?page=${data.page}`;
        case UrlPathTypes.ReviewsByMakeIndexPage:
            return `/car-reviews/${data.slug}`;
        case UrlPathTypes.ReviewsByMakePage:
            return `/car-reviews/${data.slug}?page=${data.page}`;
        case ContentTypeCodenames.GuidesArticleListingPage:
            return "/guides";
        case ContentTypeCodenames.ComparisonArticleListingPage:
            return "/comparisons";
        case ContentTypeCodenames.NewsArticleListingPage:
            return "/car-news";
        case ContentTypeCodenames.BestArticleListingPage:
            return "/best";
        case ContentTypeCodenames.EventsArticleListingPage:
            return "/company-news";
        case UrlPathTypes.EventsIndexPage:
            return `/company-news?page=${data.page}`;
        case UrlPathTypes.EventsArticlePage:
            return `/company-news/${data.slug}`;
        case UrlPathTypes.NewsArticlePage:
            return `/car-news/${data.slug}`;
        case UrlPathTypes.GuidesArticlePage:
            return `/guides/${data.slug}`;
        case UrlPathTypes.ComparisonArticlePage:
            return `/comparisons/${data.slug}`;
        case UrlPathTypes.BestArticlePage:
            return `/best/${data.slug}`;
        case UrlPathTypes.BlogIndexPage:
            return `/blog?page=${data.page}`;
        case UrlPathTypes.GuidesIndexPage:
            return `/guides?page=${data.page}`;
        case UrlPathTypes.ComparisonIndexPage:
            return `/comparisons?page=${data.page}`;
        case UrlPathTypes.NewsIndexPage:
            return `/car-news?page=${data.page}`;
        case UrlPathTypes.BestIndexPage:
            return `/best?page=${data.page}`;
        case ContentTypeCodenames.ArticlePage:
            return `/blog/${data.slug}`;
        case ContentTypeCodenames.ArticleListingPage:
            return "/blog";
        case UrlPathTypes.PressReleaseIndexPage:
            return `/company-news?page=${data.page}`;
        case ContentTypeCodenames.PRArticleListingPage:
            return "/company-news";
        case ContentTypeCodenames.PRArticlePage:
            return `/company-news/${data.slug}`;
        case ContentTypeCodenames.PressReleaseTopic:
            return `/company-news/topics/${data.slug}`;
        case ContentTypeCodenames.Topic:
            return `/blog/topics/${data.slug}`;
        case UrlPathTypes.BlogTopicPage:
            return `/blog/topics/${data.slug}?page=${data.page}`;
        case UrlPathTypes.UsedCarsIndexPage:
            return "/used-cars";
        case UrlPathTypes.BankDetailsPage:
            return "/bankdetails";
        case UrlPathTypes.UsedVansIndexPage:
            return "/used-vans";
        case UrlPathTypes.UsedCarsPage:
            return `/used-cars?page=${data.page}`;
        case UrlPathTypes.UsedVansPage:
            return `/used-vans?page=${data.page}`;
        case UrlPathTypes.CustomerCarePage:
            return "/customercare";
        case UrlPathTypes.CookiePolicyPage:
            return "/terms-and-conditions/cookie-policy";
        case UrlPathTypes.DataSubjectAccessRequestPage:
            return "/data-subject-access-request";
        case UrlPathTypes.MotorpointPlcSite:
            return "http://www.motorpointplc.com/";
        case UrlPathTypes.MotorpointPlcSiteTaxStrategyPage:
            return "http://www.motorpointplc.com/investor-relations/corporate-governance/motorpoint-group-plc-tax-strategy";
        case UrlPathTypes.VehicleSearchResults:
            return `/vehicle-search/options/${data.slug}`;
        case UrlPathTypes.BrowseCarsIndexPage:
            return "/vehicle-search/browse-cars";
        case UrlPathTypes.BrowseVansIndexPage:
            return "/vehicle-search/browse-vans";
        case UrlPathTypes.PrivacyPolicyPage:
            return "/privacy";
        case UrlPathTypes.ExtrasPage:
            return `/extras?page=${data.page}`;
        case UrlPathTypes.WhyChooseMotorpointPage:
            return "/why-choose-motorpoint";
        case UrlPathTypes.WhyChooseMotorpointPage:
            return "/home-delivery";
        case UrlPathTypes.ReserveAndCollectPage:
            return "/reserveandcollect";
        case UrlPathTypes.GenderPayGapReportPage:
            return "/gender-pay-gap-report";
        case UrlPathTypes.SameDayDriveawayPage:
            return "/samedaydriveaway";
        case UrlPathTypes.QualityStandardPage:
            return "/motorpoint-quality-standard";
        case UrlPathTypes.CustomerReviewsPage:
            return "/testimonials";
        case UrlPathTypes.SponsorshipsPage:
            return "/sponsorships";
        case UrlPathTypes.CareersSiteHomepage:
            return "https://careers.motorpoint.co.uk/";
        case UrlPathTypes.CareersSiteBranchesPage:
            return "https://careers.motorpoint.co.uk/branches";
        case UrlPathTypes.AboutPage:
            return "/about";
        case UrlPathTypes.BranchesPage:
            return "/branches";
        case UrlPathTypes.MyMotorpointPage:
            return `/mymotorpoint`;
        case UrlPathTypes.MyMotorpointLoginPage:
            return `/mymotorpoint/login`;
        case UrlPathTypes.MyMotorpointSectionPage:
            return `/mymotorpoint?page=${data.page}`;
        case UrlPathTypes.MyMotorpointMyActivityPage:
            return `/mymotorpoint/my-activity`;
        case UrlPathTypes.ValueMyCarPage:
            return "/value-my-car";
        case UrlPathTypes.FinanceIndexPage:
            return "/finance";
        case UrlPathTypes.FaqPage:
            return "/faq";
        case UrlPathTypes.NewsPage:
            return "/motorpointpr?Press-Release=on&Events=on&Competitions=on";
        case UrlPathTypes.AntiSlaveryStatementPage:
            return "/anti-slavery-statement";
        case UrlPathTypes.TermsAndConditionsPage:
            return "/termsandconditions";
        case UrlPathTypes.ShortlistPage:
            return "/favourites";
        case UrlPathTypes.SavedSearches:
            return "/favourites/searches";
        case UrlPathTypes.SavedSearchesPage:
            return `/favourites/searches?page=${data.page}`;
        case ContentTypeCodenames.AuthorProfile:
            return `/authors/${data.slug}`;
        case UrlPathTypes.AuthorProfilePage:
            return `/authors/${data.slug}?page=${data.page}`;
        case UrlPathTypes.Homepage:
        default:
            return "/";
    }
};

export default getPathByType;
